export default {
  routes: {
    butler: require('@/module/butler/routes').default,
    'master-data': require('@/module/master-data/routes').default,
    'plugin-butler-permission-manager': require('@/module/plugin-butler-permission-manager/routes').default,
    'plugin-meeting': require('@/module/plugin-meeting/routes').default,
    'plugin-tech-invest': require('@/module/plugin-tech-invest/routes').default
  },
  stores: {
    'master-data': require('@/module/master-data/store').default
  },
  hooks: {
    butler: require('@/module/butler/hook').default,
    'master-data': require('@/module/master-data/hook').default,
    'plugin-meeting': require('@/module/plugin-meeting/hook').default,
    'plugin-tech-invest': require('@/module/plugin-tech-invest/hook').default
  }
}
